import { Box, Typography } from '@percent/lemonade'
import type { SurveyQuestionWithId } from '../../../dtos/survey.dto'
import { SurveyResponseField } from '../survey-response-field/survey-response-field'
import styles from './survey-response-form.module.scss'
import { SurveyResponseFormProps } from './survey-response-form.types'

function getErrorMessage(errorValue: unknown): string | undefined {
  if (!errorValue) return undefined

  if (typeof errorValue === 'string') {
    return errorValue
  }
  if (Array.isArray(errorValue) && errorValue.length > 0) {
    return typeof errorValue[0] === 'string' ? errorValue[0] : undefined
  }
  return undefined
}

export function SurveyResponseForm({
  questions,
  values,
  errors,
  touched,
  onChange,
  onBlur,
  disabled,
  title,
  description,
  defaultPlaceholderText,
}: Readonly<SurveyResponseFormProps>) {
  return (
    <Box className={styles.Wrapper}>
      {(title || description) && (
        <Box className={styles.Item}>
          {title && (
            <Typography variant="h3" $color="text_primary">
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="default" $color="gray400">
              {description}
            </Typography>
          )}
        </Box>
      )}

      <Box className={styles.Wrapper}>
        {questions.map((question) => {
          const questionWithId = question as SurveyQuestionWithId
          const errorMessage = getErrorMessage(errors[questionWithId.id])

          return (
            <Box key={questionWithId.id}>
              <SurveyResponseField
                question={question}
                value={values[questionWithId.id]}
                onChange={(value) => onChange(questionWithId.id, value)}
                onBlur={onBlur ? () => onBlur(questionWithId.id) : undefined}
                disabled={disabled}
                error={errorMessage}
                touched={!!touched[questionWithId.id]}
                defaultPlaceholderText={defaultPlaceholderText}
              />
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
